(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxAdConfig(
    TenantListService, toastr, $filter, NetworkListService, IdpContextMenuMixin
  ) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=tenant',
        me: '=me'
      },
      templateUrl: 'app/components/authenticationSettings/activeDirectory/activeDirectory.template.html',
      link: function(scope) {

        scope.ad = angular.copy(scope.tenant.info._embedded.authenticationConfiguration.ad);
        var authenticationConfiguration = angular.copy(scope.tenant.info._embedded.authenticationConfiguration);
        var domainRegEx = /[-a-zA-Z0-9]{1,256}\.[a-z]{2,6}/;
        var portRegEx = /^([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/;
        scope.adCredentials = { username: "" , password: "" };
        scope.adConfigVerified = false;
        scope.waitingForAnswer = false;
        scope.gettingNetwork = true;
        scope.modifyAD = false;

        (function() {
          getAD_NetworkToScope();
          checkDomain();
          checkPortMax();
        })();

        function checkADConfig () {
          if (domainRegEx.test(scope.ad.defaultDomain) && portRegEx.test(scope.ad.port) && scope.ad.server && scope.ad.network && scope.adConfigVerified) {
            scope.validADConfig = true;
          } else {
            scope.validADConfig = false;
          }
        }

        function checkDomain () {
          if (domainRegEx.test(scope.ad.defaultDomain)) {
            scope.validDomain = true;
          } else {
            scope.validDomain = false;
          }
          checkADConfig();
        }

        function checkPortMax () {
          if (portRegEx.test(scope.ad.port) ) {
            scope.validPort = true;
          } else {
            scope.validPort = false;
          }
          checkADConfig()
        }

        function getAD_NetworkToScope () {
          var url = TenantListService.currentTenant.info._embedded.authenticationConfiguration.ad.network;
          if (url) {
            NetworkListService.getNetworkModelByUrl(url).then(function(network) {
              scope.selectedNetwork = network;
              scope.gettingNetwork = false;
            }).catch(function () {
              scope.selectedNetwork = null;
              scope.gettingNetwork = false;
            })
          } else {
            scope.selectedNetwork = null;
            scope.gettingNetwork = false;
          }
        }

        scope.checkDomain = function () {
          checkDomain();
        }

        scope.checkPortMax = function () {
          checkPortMax();
        }

        scope.checkADConfig = function () {
          checkADConfig();
        }

        scope.setNetwork = function (network) {
          scope.selectedNetwork = network;
          scope.ad.network = network.info._links.self.href;
        }

        scope.testAdSettings = function() {
          scope.waitingForAnswer = true;
          var adSettings = {
            defaultDomain: scope.ad.defaultDomain,
            server: scope.ad.server,
            sslEnabled: scope.ad.sslEnabled,
            port: scope.ad.port,
            enabled: scope.ad.enabled,
            network: scope.ad.network
          };
          var credentials = {
            userName: scope.adCredentials.username,
            password: scope.adCredentials.password
          };
          TenantListService.currentTenant.testTenantAdConfig(adSettings, credentials).then(function(response) {

            if (!response.data) {
              scope.adConfigVerified = true;
              toastr.success($filter("translate")("ConfigVerified"));
              saveADConfig();
            } else {
              scope.adConfigVerified = false;
              scope.waitingForAnswer = false;
              toastr.error($filter("translate")(response.data.errorCode));
            }
          }).catch(function(error) {
            scope.waitingForAnswer = false;
            scope.adConfigVerified = false;
          });
        };

        function saveADConfig () {
          authenticationConfiguration.ad = scope.ad;
          TenantListService.currentTenant.saveAuthConfigChanges(authenticationConfiguration).then(function(response) {
            scope.waitingForAnswer = false;
            if (response && response.data) {
              toastr.success($filter("translate")("ChangesSaved"));
            } else {
              toastr.warning($filter("translate")("NoChangesMade"));
            }

            if (scope.tenant.info.todoMap.SETUP_AUTH) {
              scope.tenant.removeToDoItem(scope.tenant.info.todoMap.SETUP_AUTH)
            }
          }).catch(function() {
            scope.waitingForAnswer = false;
          });
        };


        scope.toggleAD = function () {
          scope.waitingForAnswer = true;;
          const adToggleValue = scope.ad.enabled ? false : true;
          TenantListService.currentTenant.toggleAD(adToggleValue).then(function(response) {
            scope.waitingForAnswer = false;
            if (response && response.data) {
              toastr.success($filter("translate")("ChangesSaved"));
            }
          }).catch(function() {
            scope.waitingForAnswer = false;
          });
        }

        scope.toggleModifyAD = function () {
          scope.modifyAD = !scope.modifyAD;
        }


        IdpContextMenuMixin.attach(scope);

      }
    };
  }

  pxAdConfig.$inject = ['TenantListService', 'toastr', '$filter', 'NetworkListService', 'IdpContextMenuMixin'];

  angular
    .module('printix-admin')
    .directive('pxAdConfig', pxAdConfig);

})();
